module.exports = __webpack_public_path__ + "static/media/memories-from.13ad316b.jpg";